import * as React from 'react';
import { connect } from 'react-redux';
import { getVehicleData, onResetVehicleAction } from "../../vehicle";
import { getHasVehicleResolved, getVehicleInfoData, onValidVinData, onVinUpdated, onResetVehicleInfo } from "../../vehicleInfo";
import { getVehicleConfigurationAttributesRequestAction } from "../../vehicleConfigurationAttributes";
import { photoCaptureIntelligentSetOCRUserVerifiedAction, photoCaptureIntelligentUpdateUserVehicleInfoAction, photoCaptureIntelligentViewChangeAction, photoCaptureUploadAttachmentsAction } from '../actions';
import { IntelligentEstimatorVinDecodeComponent } from '../components';
import { getIntelligentEstimatorSelectedTileId, getPhotoCaptureAttachmentInfo, getPhotoCaptureCompanyCode, getPhotoCaptureContentType, getPhotoCaptureContextId, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from '../selectors';
const mapStateToProps = (state) => ({
    attachmentInfo: getPhotoCaptureAttachmentInfo(state),
    companyCode: getPhotoCaptureCompanyCode(state),
    contentType: getPhotoCaptureContentType(state),
    contextId: getPhotoCaptureContextId(state),
    hasVehicleResolved: getHasVehicleResolved(state),
    selectedTileId: getIntelligentEstimatorSelectedTileId(state),
    userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
    vehicle: getPhotoCaptureVehicle(state),
    vehicleData: getVehicleData(state),
    vehicleInfoData: getVehicleInfoData(state)
});
const mapDispatchToProps = (dispatch) => ({
    loadVehicleConfigurationAttributes: (vehicleId, dateOfLoss) => {
        dispatch(getVehicleConfigurationAttributesRequestAction({ vehicleId, dateOfLoss }));
    },
    onResetVehicleAction: () => {
        dispatch(onResetVehicleAction());
    },
    onResetVehicleInfo: (vehicleSelectionMethod, vin) => {
        dispatch(onResetVehicleInfo(vehicleSelectionMethod, vin));
    },
    onUploadAttachments: (attachmentInfo, contextId, coCode) => {
        dispatch(photoCaptureUploadAttachmentsAction(attachmentInfo, contextId, coCode));
    },
    onUpdateUserVehicleInfo: (userVehicleInfo) => {
        dispatch(photoCaptureIntelligentUpdateUserVehicleInfoAction(userVehicleInfo));
    },
    onValidVinData: (vehicleInfo, vin, vid, serviceBarcode, hasSelectionMethodChanged) => {
        dispatch(onValidVinData(vehicleInfo, vin, vid, serviceBarcode, hasSelectionMethodChanged));
    },
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onVinUpdated: (vin, vehicleSelectionMethod) => {
        dispatch(onVinUpdated(vin, vehicleSelectionMethod));
    },
    onSetOCRUserVerified: (contentType) => {
        dispatch(photoCaptureIntelligentSetOCRUserVerifiedAction(contentType));
    }
});
const IntelligentEstimatorVinDecodeComponentWrapper = (props) => React.createElement(IntelligentEstimatorVinDecodeComponent, Object.assign({}, props));
export const ConnectedIntelligentPhotoCaptureEstimatorVinDecodeView = connect(mapStateToProps, mapDispatchToProps)(IntelligentEstimatorVinDecodeComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureEstimatorVinDecodeView.js.map